import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=27c43fa8&scoped=true&"
import script from "./Resume.vue?vue&type=script&lang=js&"
export * from "./Resume.vue?vue&type=script&lang=js&"
import style0 from "./Resume.vue?vue&type=style&index=0&id=27c43fa8&lang=less&scoped=true&"
import style1 from "./Resume.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c43fa8",
  null
  
)

export default component.exports